export default {
  newDesign: true,
  downtimeUrl: "https://cl.kodland.tech",
  startPage: {
    startBackground: "white",
    quizBackground: "#white",
    title:
      "Responde 3 preguntas y obtén una divertida lección de matemáticas ¡GRATIS!",
    subtitle:
      "En la lección: <br>• Se explicará cómo aprender matemáticas a través de un juego <br>• Se determinará tu nivel de conocimiento <br>• Se te mostrará cómo puedes mejorar tus habilidades matemáticas",
    image: {
      url: "/welcome/quiz_latam_early_math_pk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/quiz_latam_early_math_mobile.png",
      style: {
        width: "100%",
      },
    },
    button: " Comenzar🚀 ",
  },
  // successPage: {
  //   title: "¡Felicitaciones! 🎁",
  //   subtitle: "Haz clic en '📆 Reservar una clase' para completar el registro",
  //   button: "📆 Reservar una clase",
  // },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "¡Gracias por confiar en nuestra plataforma educativa!",
    subtitle:
      "Desafortunadamente, las tabletas o los teléfonos no son adecuados para tomar nuestras lecciones. ¡Estaremos felices de verlos en nuestras clases la próxima vez!",
  },
  quizRotateBySteps: {
    1: {
      question:
        "¿El niño tiene experiencia aprendiendo matemáticas, lógica o aritmética?",
      answers: [
        "Sí, estudió en la escuela",
        "Sí, estudió con los padres",
        "Sí, estudió en cursos o en el jardín de infancia",
        "No, no tiene experiencia",
      ],
    },
    2: {
      question: "¿Qué esperas de la primera lección gratuita?",
      answers: [
        "🔢 Descubrir el nivel actual de mi hijo",
        "🎯 Aprender a enfrentarse a desafíos",
        "📈 Aumentar la motivación de mi hijo",
        "🎲 Aprender a enseñarle matemáticas a mi hijo a través del juego",
      ],
    },
    3: {
      question: "¿Qué es lo más importante para ti en la educación de tu hijo?",
      answers: [
        "🤩 Actividades interactivas y divertidas",
        "🚀 Calidad de la educación",
        "💁🏼‍♂️ Enfoque individual",
        "💰 Relación calidad/precio",
        "👩🏽‍🏫 Profesor experto",
      ],
    },
    4: {
      question:
        "¿Tienes una computadora de escritorio/portátil donde puedas trabajar?",
      answers: [
        "💻 Sí",
        {
          answer: "😐 No",
          stopAnswer: true,
        },
      ],
    },
    5: {
      title: "¿Qué edad tiene tu hijo/a?",
      type: "age",
      subtitle:
        "Elegiremos el curso más entretenido según la edad de tu hijo/a",
      button: "",
    },
    6: {
      title: "¡Felicitaciones! 🎉",
      typeInfo: "congrats",
      subtitle:
        "Haz clic en '📆 Reservar una clase' para completar el registro",
      button: "📆 Reservar una clase",
    },
    7: {
      title: "Reserva una clase gratuita",
      type: "one-page-contacts",
      subtitle: "",
      button: "Casi terminamos 🔥",
    },
    8: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    9: {
      title:
        "¡Gracias! Has agendado con éxito tu primera clase de prueba gratuita 🎉",
      typeInfo: "pc-laptop",
      subtitle:
        "Ten en cuenta que para la lección necesitaras una PC o laptop en funcionamiento y que deberás acompañar a tu hijo/a durante toda la clase. Recuerda que la misma es individual y personalizada.",
      button: "¿Qué más?",
    },
    10: {
      title: "Chequea tu correo y WhatsApp antes de la clase de prueba📞",
      typeInfo: "whatsapp",
      subtitle:
        "24hs antes estaremos enviándote un recordatorio y 2 horas antes de la clase te pediremos que confirmes tu asistencia. Es muy importante que estemos en contacto para que la clase no se cancele.",
      button: "¿Qué más?",
    },
    11: {
      title: "La clase se realizará en nuestra plataforma 💻",
      typeInfo: "classroom",
      subtitle:
        "Recibirás un enlace y un código único por WhatsApp y correo electrónico. Solo haz clic en el enlace y te llevará directo a la clase. Sin apps adicionales, sin descargas.",
      button: "Entendido ✅",
    },
  },
};
